;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { ComboboxOption } from '@qogita/ui/v2/combobox'

/** A single search result to show in the search combobox */
export function SearchResult({
  href,
  displayValue,
}: {
  href: string
  displayValue: string
}) {
  return (
    // oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component
    <ComboboxOption value={href} className="px-3 py-2">
      {displayValue}
    </ComboboxOption>
  )
}
